import { render, staticRenderFns } from "./rooming_lists.vue?vue&type=template&id=2ba32d04&"
import script from "./rooming_lists.vue?vue&type=script&lang=js&"
export * from "./rooming_lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports